/**
 * @fileoverview JSS styles for AnnouncementsCard.js
 */

const styles = (theme) => ({});

export default styles;
